const { REACT_APP_CLOUDFORESTX_BASE_API_URL } = process.env;

export default {
  apiBaseUrl: REACT_APP_CLOUDFORESTX_BASE_API_URL,
};


